export default {
  // ========== Botones y acciones ==========
  evaluations: 'Evaluaciones',

  // ========== Reportes IA ==========
  aiActionsButton: 'IA',
  pertinenceReportTitle: 'Comparación del {entity}',
  pertinenceButtonText: 'Comparación del {entity}',
  pertinenceButtonTooltip: 'Analizar comparación nacional e internacional del {entity} con IA',
  pedagogicalReportTitle: 'Evaluación Pedagógica del {entity}',
  pedagogicalButtonText: 'Evaluación Pedagógica del {entity}',
  pedagogicalButtonTooltip: 'Evaluar pedagógicamente el {entity} desde el enfoque evolutivo y coherencia estructural con IA',

  // ========== Descarga de documentos ==========
  formatCreationPlanAndMatter: 'Formato Creación Plan y Asignatura',
  valuationReport: 'Reporte de Valorización',
  mattersReport: 'Reporte de',
  outputFormat: 'Formato de salida de',

  // ========== Generación de archivos ==========
  generatingWord: 'Generando Word...',

  // ========== Estados y cambios ==========
  changeStateOf: 'Cambiar el estado de la',

  // ========== EgressProfile Component ==========
  notApply: 'No Aplica.',
  introduce: 'Introduzca el',
  duration: 'Duración',
  durationOf: 'Duración del',
  yearOfEntry: 'Año de entrada en vigencia',
  wording: 'Redacción',
  alreadyInUse: 'ya está siendo utilizado.',
  enterValidYear: 'Ingrese un año válido',
  edit: 'Editar los',
  write: 'Redactar',
  selectOneOrMultiple: 'Seleccione uno o varias',
  ifDefaultSelected: 'Si se selecciona el predeterminado, se habilitará el enunciado del descriptor en otros',
  noToShow: 'para mostrar',
  whenCancelingDuration: 'Al cancelar, la duración del {entity} volverá a su estado original.',
  cancel: 'Cancelar',
  applyChanges: 'Aplicar cambios',
  attachments: 'Anexos',

  // ========== Métodos - Mensajes de confirmación ==========
  sureDeleteDescriptiveTitle: '¿Está seguro de que desea eliminar el título descriptivo?',
  actionIrreversibleDeleteObjects: 'Esta acción no se podrá revertir y se eliminarán los objetos referenciados en la parte inferior.',
  title: 'Título',
  content: 'contenido',
  sureDeleteDescriptiveTitleContent: '¿Está seguro de que desea eliminar el contenido del título descriptivo?',
  actionIrreversibleAffectOthers: 'Esta acción no se podrá revertir y podria afectar a otros',
  sureDeleteAssociation: '¿Está seguro de que desea eliminar la asociación de esta instancia de',
  inThe: 'en el',
  cannotBeEmpty: 'El {entity} no puede estar vacío.',
  mustDefineNumericDuration: 'Debe definir una cantidad de Duración con un valor numérico.',

  // ========== EgressProfileFileView Component ==========
  addAttachment: 'Agregar Anexo',
  files: 'Archivos',
  deleteAttachment: 'Eliminar Anexo',
  noAttachmentsToShow: 'No hay anexos para mostrar.',
  selectWordFileOrDrag: 'Seleccione un archivo Word(.docx) o arrástrelo aquí...',
  fileSizeExceeded: 'El archivo no puede superar {size} de tamaño.',
  invalidWordFile: 'No es un archivo de Word(.docx) válido.',
  uploadingFile: 'Subiendo archivo...',
  pleaseWaitWhileUploading: 'Por favor, espera mientras se sube el archivo.',
  problemUploadingFile: 'Hubo un problema al subir el archivo.',
  sureDeleteAttachment: '¿Está seguro de que desea eliminar el anexo?',
}
